import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _types$SHOW_TOAST$typ;

import * as types from "@/store/constants/types";
import { i18n } from "@/i18n/i18n-setup";
export default (_types$SHOW_TOAST$typ = {}, _defineProperty(_types$SHOW_TOAST$typ, types.SHOW_TOAST, function (state, payLoad) {
  state.toastData = payLoad;
}), _defineProperty(_types$SHOW_TOAST$typ, types.HIDE_TOAST, function (state, payLoad) {
  state.toastData = {
    show: false
  };
}), _defineProperty(_types$SHOW_TOAST$typ, types.SHOW_FACE_TOAST, function (state, payLoad) {
  var data = {
    show: true,
    topImg: require("@/assets/toast/frame_alert.png"),
    content: i18n.t("toast.face_toast"),
    confirm: "<div class=\"flex-center\" style=\"width:100%;height:100%;background: #603BF3;font-size:18px;font-family:Assistant-SemiBold;color:#fff;border-radius: 8px;\">".concat(i18n.t("toast.retry"), "</div>")
  };
  data.confirmFn = payLoad;
  state.toastData = data;
}), _defineProperty(_types$SHOW_TOAST$typ, types.SHOW_NETWORK_TOAST, function (state, payLoad) {
  var data = {
    show: true,
    topImg: require("@/assets/toast/no_network_alert.png"),
    content: i18n.t("toast.minor_prablem"),
    confirm: "<div class=\"flex-center\" style=\"width:100%;height:100%;background: #603BF3;font-size:18px;font-family:Assistant-SemiBold;color:#fff;border-radius: 8px;\">".concat(i18n.t("toast.done"), "</div>")
  };
  data.confirmFn = payLoad;
  state.toastData = data;
}), _defineProperty(_types$SHOW_TOAST$typ, types.UPDATE_LOADING_STATUS, function (state, payLoad) {
  state.showLoaing = payLoad;
}), _types$SHOW_TOAST$typ);